import type { MaybeRefOrGetter } from 'vue'
import { computed, toValue } from 'vue'
import { useDevOidcProfilesOverride } from '~/composables/auth/useDevOidcProfilesOverride'
import { isPublicRoutePath } from '~/composables/auth/usePublicRoutes'

export type LayoutAuthMode = 'auto' | 'required' | 'public'

export function useAppLayoutShell(authMode: MaybeRefOrGetter<LayoutAuthMode>) {
  const route = useRoute()
  const { loggedIn } = useOidcAuth()
  const { isActive: devOidcOverrideBanner } = useDevOidcProfilesOverride()

  const showDevOidcProfilesBar = computed(() => import.meta.dev && loggedIn.value)

  const shouldUseAuthGate = computed(() => {
    const mode = toValue(authMode)
    if (mode === 'public') {
      return false
    }
    if (mode === 'required') {
      return true
    }
    return !isPublicRoutePath(route.path)
  })

  const showBackToNationalView = computed(() => {
    const normalized = route.path.replace(/\/$/, '') || '/'
    if (normalized === '/parametres' || normalized.startsWith('/parametres/')) {
      return true
    }
    return normalized === '/admin' || normalized.startsWith('/admin/')
  })

  return {
    devOidcOverrideBanner,
    showDevOidcProfilesBar,
    shouldUseAuthGate,
    showBackToNationalView,
  }
}
